import { AppStateType } from '../reducers'
import { IGroupEditorsState } from '../types/editorsPerGroup'

export const selectGroupEditorsData = (
  { editorsPerGroup }: AppStateType,
  groupId: string
): ( IGroupEditorsState | {} ) => editorsPerGroup[groupId] || {} // FIXME: wrong retrun type
